import React from 'react';
import PContacts from './pages/PContacts';

const Contacts = () => <PContacts />;

export default Contacts;
